import {Genre} from './cms-vod-core/content-controller/genre-model';
import {ContentLanguageMetadata} from './content-language-metadata.model';
import { ContentSectionInfo } from './cms-vod-core/content-controller/content-section-info.model';
import {MetadataCastTypeMap} from './metadata-cast-type-map.model';
import {Tag} from './tag.model';

export class Metadata {
  constructor(
    public id?: number,
    public aspectRatio?: string,
    public metadataCastTypeMaps?: MetadataCastTypeMap[],
    public audioType?: string,
    public codec?: string,
    public contentLanguageMetadatas?: ContentLanguageMetadata[],
    public country?: string,
    public director?: string,
    public duration?: number,
    public epgProgramId?: string,
    public epgExternalId?: string,
    public episodeNo?: number,
    public imdbRating?: string,
    public originalLanguage?: string,
    public originalTitle?: string,
    public rating?: string,
    public advices?: string,
    public resolution?: string,
    public screenFormat?: string,
    public seasonNo?: any,
    public studio?: string,
    public subtitle?: string,
    public summaryLong?: string,
    public originalSummaryLong?: string,
    public summaryShort?: string,
    public title?: string,
    public videoFormats?: string[],
    public year?: string,
    public tags?: Tag[],
    public additionalData?: string,
    public genres?: Genre[],
    public provider?: string,
    public imdbId?: string,
    public contentSectionInfo?: ContentSectionInfo,
    public isSd?: boolean,
    public isHd?: boolean,
    public isFhd?: boolean,
    public isUhd?: boolean,
    public isDolby?: boolean,
  ) {}
}
// Metadata {
//   additionalData (string, optional),
//   aspectRatio (string, optional),
//   audioType (string, optional),
//   casts (Array[ContentCast], optional),
//   codec (string, optional),
//   contentLanguageMetadatas (Array[ContentLanguageMetadata], optional),
//   country (string, optional),
//   duration (integer, optional),
//   epgProgramId (string, optional),
//   episodeNo (integer, optional),
//   genres (Array[Genre], optional),
//   id (integer, optional),
//   imdbRating (number, optional),
//   originalLanguage (string, optional),
//   originalTitle (string, optional),
//   provider (string, optional),
//   rating (string, optional),
//   resolution (string, optional),
//   screenFormat (string, optional),
//   seasonNo (integer, optional),
//   studio (string, optional),
//   subtitle (string, optional),
//   summaryLong (string, optional),
//   summaryShort (string, optional),
//   tags (Array[Tag], optional),
//   title (string, optional),
//   videoFormats (Array[string], optional),
//   year (string, optional)
//   }

// "metadata": {
//   "id": 92,
//   "title": "Man on Fire",
//   "originalTitle": "Man on Fire",
//   "duration": null,
//   "summaryShort": "John, an ex-CIA officer, is entrusted with the responsibility of safeguarding an entrepreneur's daughter. When the girl gets kidnapped, John vows to seek revenge.",
//   "summaryLong": "John, an ex-CIA officer, is entrusted with the responsibility of safeguarding an entrepreneur's daughter. When the girl gets kidnapped, John vows to seek revenge.John, an ex-CIA officer, is entrusted ",
//   "director": "Tony Scott",
//   "actors": [
//       {
//           "name": "Dokatta Fanning",
//           "posterUrl": "https://upload.wikimedia.org/wikipedia/commons/7/73/Dakota_Fanning_SAG_AWARDS_2020.jpg"
//       },
//       {
//           "name": "Christopher Walken",
//           "posterUrl": "https://smartcdn.prod.postmedia.digital/canoe/wp-content/uploads/2020/10/WALKEN-2020-10-03.jpg?quality=90&strip=all&w=564&type=webp"
//       }
//   ],
//   "studio": null,
//   "audioType": null,
//   "resolution": null,
//   "codec": null,
//   "screenFormat": null,
//   "originalLanguage": null,
//   "country": null,
//   "subtitle": null,
//   "rating": null,
//   "imdbRating": "7.7",
//   "videoFormats": [],
//   "aspectRatio": null,
//   "year": "2004",
//   "epgProgramId": null,
//   "episodeNo": null,
//   "seasonNo": null
// },
